import { createReducer, on } from '@ngrx/store';
import { BaseTag } from '@sleipai/sleip-models';
import * as TagActions from '../actions/tag.actions';
import * as GroupTagActions from '../actions/group-tag.actions';
import { GroupTagState, groupTagAdapter } from '../entity/group-tag.entity';

export const tagFeatureKey = 'tag';

export interface State {
  loading: boolean;
  loaded: boolean;
  error: string | null;
  tags: { [category: string]: { [id: string]: BaseTag } };
  groupTags: GroupTagState;
}

export const initialState: State = {
  loading: false,
  loaded: false,
  error: null,
  tags: {},
  groupTags: groupTagAdapter.getInitialState(),
};

export const reducer = createReducer(
  initialState,

  on(TagActions.loadTags, (state) => ({
    ...state,
    loading: true,
  })),
  on(TagActions.loadTagsSuccess, (state, { tags }) => ({
    ...state,
    loaded: true,
    loading: false,
    tags: {
      ...state.tags,
      ...tags,
    },
  })),
  on(TagActions.loadTagsFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    loading: false,
    error: error,
  })),

  on(GroupTagActions.loadGroupTagsForGroup, (state) => ({
    ...state,
    loaded: false,
    loading: true,
  })),
  on(GroupTagActions.loadGroupTagsForGroupSuccess, (state, { groupTags }) => ({
    ...state,
    loaded: true,
    loading: false,
    groupTags: groupTagAdapter.upsertMany(groupTags, state.groupTags),
  })),
  on(GroupTagActions.loadGroupTagsForGroupFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    loading: false,
    error: error,
  }))
);
